/**
 * Rules every programme review decision shares, from internal review to final
 * sign-off. Pure, so the decision form refuses in the server's words.
 *
 * @module server/review-decision
 */

import { blockersForGate } from "./readiness-ladder";
import type { ReadinessBlocker } from "./types";

export const DECISION_COMMENT_REQUIRED = "Add a comment to record this decision.";

/** The comment as it is stored, or `undefined` when there is none to store. */
export function decisionComment(note: string | undefined): string | undefined {
  const trimmed = note?.trim();
  return trimmed || undefined;
}

/**
 * Blockers a reviewer accepts by marking reviewed: what QA approval, the next
 * gate, still waits on.
 */
export function openReviewBlockers<T extends Pick<ReadinessBlocker, "gates">>(
  blockers: readonly T[],
): T[] {
  return blockersForGate(blockers, "Ready for approval");
}
